import {
  enableProdMode,
  NgModuleRef,
} from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { MainModule } from './app/main/main.module';

if (window['environment'] === 'stage' || window['environment'] === 'prod') {
  enableProdMode();
}

export let mainModule: NgModuleRef<MainModule>;

platformBrowserDynamic().bootstrapModule(MainModule).then((module: NgModuleRef<MainModule>) => {
  mainModule = module;
});
